module.exports = require('./helpers/bundle-url').getBundleURL('eeGpe') + "logo.c51670a8.svg";